<template>
  <div class="chat-selected-contacts">
    <div class="chat-selected-contacts-wrapper" :class="{ overflow, wrap }">
      <new-chat-selected-contact
        v-for="(contact, index) in selectedContacts"
        :index="wrap ? index + 1 : index"
        :contact="contact"
        :actionIcon="actionIcon"
        :key="`${contact.profileId}-${contact.userType}`"
        @contact:action="$emit('contact:remove', $event)" />
    </div>
  </div>
</template>

<script>
import NewChatSelectedContact from "@/components/chat/components/NewChatSelectedContact.vue"

export default {
  name: 'NewChatSelectedContacts',
  components: {
    NewChatSelectedContact
  },
  props: {
    selectedContacts: {
      type: Array,
      default: () => []
    },
    actionIcon: {
      type: String,
      default: ''
    },
    wrap: {
      type: Boolean,
      default: false
    },
    overflow: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.chat-selected {
  &-contacts {
    position: relative;
    height: $chat-selected-users-section-height;
  }

  &-contacts-wrapper {
    display: flex;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin-left:-16px;
    &.wrap {
      flex-wrap: wrap;
    }

    &.overflow {
      overflow: hidden;
      overflow-x: auto;
    }
  }
}
</style>
